export class Setting {
    constructor(
      public id: string,
      public name: string,
      public appName: string,
      public icon: string,
      public banner: string,
      public email: string,
      public emailSenderName: string,
      public emailSender: string,
      public emailSupport: string,
      public baseURL: string,
      public privacyPolicy: string,
      public backupFrequency: number,
      public isBackupActive: boolean,
      public androidId: string,
      public androidURL: string,
      public androidVersion: string,
      public appStoreId: string,
      public appStoreURL: string,
      public appStoreVersion: string,
      public contentLanguage: string,
      public letterTitle: string,
      public letterMessage: string,
      public letterFooter: string,
      public classbookNotificationType: string,
      public classbookReplyAllowed: boolean,
      public optionMessageCategories: boolean,
      public translationStatus: boolean,
      public translationDisableLanguages: any,
      public copyrightTextImages: string,
      public imageDownloadAllowed: boolean,
      public classBookDisabled: boolean,
      public notifyUsersWithSameSecret: boolean,
      public userFields: any[],
      public messageStartDate: Date,
      public classbookStartDate: Date,
      public isImportantAdmin: boolean,
      public isImportantTeacher: boolean,
      public dataConfirmationFieldId: string,
      public richTextMessages?: boolean,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/shared/setting.model.ts